module.exports = __webpack_public_path__ + "static/media/31-6.80f6621c.mp3";